import { GENERAL_PHRASES } from '@/consts/phrases/generalPhrases';
import { usePhrase, useRouter } from '@/hooks';
import { Modal, Typography, Grid, Button, IconButton, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface LoginPopupProps {
    showPopup: boolean;
    startLink: string | undefined;
    phraseId: number | undefined;
    closePopup: () => void;
}

export const LoginPopup: React.FC<LoginPopupProps> = ({
    showPopup,
    startLink,
    phraseId,
    closePopup,
}) => {
    const { t } = usePhrase();
    const router = useRouter();

    const onContinueClicked = () => {
        if (startLink) {
            router.push(startLink);
            closePopup();
        }
    };
    return (
        <Modal
            open={showPopup}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
            onClose={closePopup}
        >
            <Grid
                container
                sx={(theme) => ({
                    background: theme.palette.background.default,
                    width: ['100%', '65%', '30%'],
                    padding: theme.spacing(2),
                    borderRadius: '10px',
                    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                })}
            >
                <Grid size={12} style={{ textAlign: 'right' }}>
                    <IconButton aria-label="close" data-testid="closeButton" onClick={closePopup}>
                        <CloseIcon />
                    </IconButton>
                </Grid>
                {startLink ? (
                    <Grid size={12} style={{ display: 'flex', justifyContent: 'center' }}>
                        <Stack
                            spacing={2}
                            sx={{
                                alignItems: 'center',
                            }}
                        >
                            <Typography variant="body1" sx={{ pb: 2 }}>
                                {t(phraseId)}
                            </Typography>
                            <Button variant="contained" color="primary" onClick={onContinueClicked}>
                                {t(GENERAL_PHRASES.CONTINUE)}
                            </Button>
                        </Stack>
                    </Grid>
                ) : (
                    <Grid size={12} style={{ display: 'flex', justifyContent: 'center' }}>
                        <Typography variant="body1">{t(phraseId)}</Typography>
                    </Grid>
                )}
            </Grid>
        </Modal>
    );
};
